import * as API from '../../../requests'
import {filterRecords, inverseFilterRecords} from '../../../record_selection'
import utils from '@eitje/utils'

const staticMethodsCache = new WeakMap()
const whereCache = new WeakMap()

const getStaticMethods = modelClass => {
	let methods = staticMethodsCache.get(modelClass)
	if (methods) return methods

	// Static method discovery is class-level metadata; forwarding functions are still association-specific.
	methods = Object.getOwnPropertyNames(modelClass).filter(methodName => {
		return (
			methodName !== 'length' &&
			methodName !== 'prototype' &&
			methodName !== 'name' &&
			methodName !== 'caller' &&
			methodName !== 'arguments' &&
			typeof modelClass[methodName] === 'function'
		)
	})
	staticMethodsCache.set(modelClass, methods)
	return methods
}

class Association extends Array {
	constructor(props) {
		const items = utils.alwaysArray(props)
		super(...items)

		if (items.length > 0) {
			const modelClass = items[0].constructor
			getStaticMethods(modelClass).forEach(methodName => {
				this[methodName] = (...args) => modelClass[methodName](this, ...args)
			})
		}
	}

	static get [Symbol.species]() {
		return this
	}

	ids() {
		return this.map(i => i.id)
	}

	multiUpdate(payload) {
		const tableName = this.first().snakeTableName()
		const params = this.map(i => ({id: i.id, ...payload}))
		return API.updateMulti(tableName, params)
	}

	where(query) {
		return cachedWhere(this, query)
	}

	whereNot(query) {
		return inverseFilterRecords(this, query)
	}

	first() {
		return this[0]
	}

	last() {
		return this[this.length - 1]
	}

	tableName() {
		return this.first().tableName
	}
}

const cachedWhere = (association, query) => {
	const queryValues = query && Object.values(query)
	if (queryValues?.length && queryValues.every(value => value === undefined)) return filterRecords(association, query)

	const cacheKey = JSON.stringify(query)
	let cache = whereCache.get(association)
	if (!cache) {
		cache = new Map()
		whereCache.set(association, cache)
	}

	if (cache.has(cacheKey)) return cache.get(cacheKey)

	cache.set(cacheKey, filterRecords(association, query))
	return cache.get(cacheKey)
}

export default Association
